import React from 'react'
import LoaderV1 from './LoaderV1'

/**
 * Loader orchestrator – selects loader variant based on uiConfig.general.loaderVariant
 * Supports string ("v2") or object ({ variant: "v2", ... }) forms.
 */
const Loader = (props) => {
  // const { general } = useSelector(state => state.uiConfig)
  // const cfg = general?.loaderVariant || {}
  // const variant = typeof cfg === 'object' && cfg?.variant ? cfg.variant : cfg
  // return variant === 'v2' ? <LoaderV2 /> : <LoaderV1 {...props} />
  return <LoaderV1 {...props} />
}

export default Loader
